import React, { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  Marker,
  Polyline,
  Polygon,
  Circle,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import trailApi from "../api/trails";
import MultiselectDropdown from "../components/MultiselectDropdown";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import TeamDetails from "../components/TeamDetails";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import {
  CarMarker,
  CrossIcon,
  getInTrailPoisSvg,
  getTeamNumberSvg,
  HideCarIcon,
  HideDetailsIcon,
  HideFilterIcon,
  Loader,
  MapRecenter,
  OnTrailPowerOnOff,
  RefreshIcon,
  RoadMap,
  Satelite,
  ShowCarIcon,
  ShowDetailsIcon,
  ShowFilterIcon,
  DrawIcon,
  DrawIconDisable,
  FocusIcon,
} from "../svgs/SVGs";
import {
  calculateCenter,
  convertKeysToCamelCase,
  extractAndCapitalizePOIsInitial,
  SpeedStatus,
} from "../utility/UtilFunctions";
import LoginPage from "../components/Login";
import Cookies from "js-cookie";
import { Tooltip } from "@mui/material";
import ArcMarker from "../components/ArcMarker";
import Swal from "sweetalert2";

function Index() {
  const [accessToken, setAccessToken] = useState("");

  const [editions, setEditions] = useState([]);
  const [selectedEdition, setSelectedEdition] = useState();

  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState();

  const [teams, setTeams] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchAccessTokenFromCookie = () => {
      //console.log("running");
      const accesstoken = Cookies.get("accesstoken");
      if (accesstoken) {
        setAccessToken(accesstoken);
      } else {
        setAccessToken("");
      }
    };

    fetchAccessTokenFromCookie();

    const interval = setInterval(fetchAccessTokenFromCookie, 2000);

    return () => clearInterval(interval);
  }, []);

  const mapRef = useRef(null);

  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const [polygons, setPolygons] = useState([]);

  const [inTrailMarkers, setInTrailMarkers] = useState({ teamInfo: [] });

  const [inTrailPowerOnOffMarkers, setInTrailPowerOnOffMarkers] = useState({
    teamInfo: [],
  });

  const [startFinishMarkers, setStartFinishMarkers] = useState([]);

  const [gpsTrackerMarkers, setgpsTrackerMarkers] = useState([]);

  const [stageTeamJourneys, setStageTeamJourneys] = useState([]);

  const [bonusGroupDetails, setBonusGroupDetails] = useState([]);

  const [allOtherTeamsCurrentLocations, setAllOtherTeamsCurrentLocations] =
    useState([]);

  const [selectedMarker, setSelectedMarker] = useState(null);

  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  const [isLoadingTrailsData, setIsLoadingTrailsData] = useState(false);

  const [polylines, setPolylines] = useState([]);

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    setEditingPOIs(false);
  };

  useEffect(() => {
    if (isOpen) {
      setIsLoadingDetails(true);
      getFurtherDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const [showCurrentLocation, setShowCurrentLocation] = useState(false);
  const togglePins = () => {
    setShowCurrentLocation((prevState) => !prevState);
  };

  const ReCenterToEurope = () => {
    console.log("minLatLng", minLatLng);
    console.log("maxLatLng", maxLatLng);
    // Adjust map bounds
    if (mapRef.current) {
      if (
        maxLatLng.lat === 0 &&
        maxLatLng.lng === 0 &&
        minLatLng.lat === 0 &&
        minLatLng.lng === 0
      ) {
        const bounds = new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(35.0, -10.0),
          new window.google.maps.LatLng(71.0, 40.0)
        );
        mapRef.current.fitBounds(bounds);
        mapRef.current.setZoom(5);
      } else {
        const bounds = new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(minLatLng),
          new window.google.maps.LatLng(maxLatLng)
        );
        mapRef.current.fitBounds(bounds);
      }
    }
  };

  const [center, setCenter] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const [maxLatLng, setMaxLatLng] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const [minLatLng, setMinLatLng] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  useEffect(() => {
    getFiltersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log(
    //   "selectedEdition",
    //   selectedEdition ? selectedEdition[0]?.value : 0
    // );
    getFiltersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEdition]);

  useEffect(() => {
    getPolylineData();
    if (showGpsTrackerTrail && selectedTeams?.length > 0) {
      setDeviceId(selectedTeams[0]?.extraData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEdition, selectedStage, selectedTeams]);

  // useEffect(() => {
  //   if (isOpen) {
  //     setIsLoadingDetails(true);
  //     getFurtherDetails();
  //   }
  //   console.log("updatedMarkerReg");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [allOtherTeamsCurrentLocations]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getPolylineData = async (requestFromPool = false) => {
    try {
      if (!requestFromPool) {
        setIsLoadingTrailsData(true);
      }

      const response = await trailApi.getpolylinedate(
        selectedEdition ? selectedEdition[0]?.value : 0,
        selectedStage ? selectedStage[0]?.value : 0,
        selectedTeams ? selectedTeams.map((item) => item.value) : [],
        showCompleteEditionTrail
      );

      const centerLat = response.data.CenterLatitude;
      const centerLng = response.data.CenterLongitude;
      const minLat = response.data.MinLatitude;
      const minLng = response.data.MinLongitude;
      const maxLat = response.data.MaxLatitude;
      const maxLng = response.data.MaxLongitude;

      if (mapRef.current && !requestFromPool) {
        setCenter({ lat: centerLat, lng: centerLng });
        setMinLatLng({ lat: minLat, lng: minLng });
        setMaxLatLng({ lat: maxLat, lng: maxLng });

        if (maxLat === 0 && maxLng === 0 && minLat === 0 && minLng === 0) {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(35.0, -10.0),
            new window.google.maps.LatLng(71.0, 40.0)
          );
          mapRef.current.fitBounds(bounds);
          mapRef.current.setZoom(5);
        } else {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(minLat, minLng),
            new window.google.maps.LatLng(maxLat, maxLng)
          );
          mapRef.current.fitBounds(bounds);
        }
      }

      const polylineCamelCaseData = convertKeysToCamelCase(
        response.data.PolylineModel.Polylines
      );
      setPolylines(polylineCamelCaseData);

      const polygonCamelCaseData = convertKeysToCamelCase(
        response.data.PolylineModel.Polygons
      );

      console.log("polygonCamelCaseData", polygonCamelCaseData);

      setPolygons(polygonCamelCaseData);

      setStartFinishMarkers(response.data.PolylineModel.TeamMarkers);

      setBonusGroupDetails(response.data.BonusGroupPois);

      //console.log(response.data.BonusGroupPois);

      // response.data.Data.TrailModels.map((x) => (console.log(x)));

      const teamInfo = response.data?.Data?.TrailModels?.map((x) => {
        return {
          teamId: x.TeamId,
          teamName: x.TeamName,
          teamNumber: x.TeamNumber,
          hsl1: x.TrailHsl_1,
          hsl2: x.TrailHsl_2,
          markers:
            x.POIsOnTrailCoordinate?.map((marker) => ({
              gpsDataId: marker.GpsDataId,
              position: {
                lat: marker.CoordinateLatitude,
                lng: marker.CoordinateLongitude,
              },
              direction: marker.Direction,
              occuredTimeToLocal: marker.OccuredTimeToLocal,
              speed: marker.Speed,
              pois: marker.POIs,
            })) || [], // If no POIsOnTrailCoordinate, return empty array
        };
      });

      setInTrailMarkers({ teamInfo: teamInfo });

      const teamInfo2 = response.data?.Data?.TrailModels?.map((x) => {
        return {
          teamId: x.TeamId,
          teamName: x.TeamName,
          teamNumber: x.TeamNumber,
          hsl1: x.TrailHsl_1,
          hsl2: x.TrailHsl_2,
          markers:
            x.PowerOnOffOnTrailCoordinate?.map((marker) => ({
              gpsDataId: marker.GpsDataId,
              position: {
                lat: marker.CoordinateLatitude,
                lng: marker.CoordinateLongitude,
              },
              direction: marker.Direction,
              occuredTimeToLocal: marker.OccuredTimeToLocal,
              speed: marker.Speed,
              eventName: marker.EventName,
            })) || [], // If no PowerOnOffOnTrailCoordinate, return empty array
        };
      });

      setInTrailPowerOnOffMarkers({ teamInfo: teamInfo2 });

      setAllOtherTeamsCurrentLocations(response.data?.Data?.PinPointModels);

      setIsLoadingTrailsData(false);
    } catch (er) {
      console.log(er);
      setIsLoadingTrailsData(false);
    }
  };

  const getFiltersData = async (showGpsTrackerTrail) => {
    try {
      // const editionId = selectedEdition?

      setSelectedStage({});
      setSelectedTeams([]);

      const response = await trailApi.getfilters(
        selectedEdition ? selectedEdition[0]?.value : 0,
        selectedStage ? selectedStage[0]?.value : 0,
        selectedTeams ? selectedTeams.map((item) => item.value) : [],
        showGpsTrackerTrail
      );
      const filters = convertKeysToCamelCase(response.data.Filters);

      setEditions(filters.editions);
      setStages(filters.stages);
      setTeams(filters.teams);

      //console.log(filters);
    } catch (er) {
      console.log(er);
    }
  };

  const getFurtherDetails = async () => {
    try {
      const response = await trailApi.getfurtherdetails(
        selectedStage ? selectedStage[0]?.value : 0,
        selectedTeams ? selectedTeams.map((item) => item.value) : []
      );

      // const response = await trailApi.getfurtherdetails(210, [34, 92]);

      setStageTeamJourneys(response.data?.StageTeamJourneys);
      console.log("data here: ", response.data?.StageTeamJourneys);

      setIsLoadingDetails(false);
    } catch (er) {
      console.log(er);
    }
  };

  const reloadDetails = async () => {
    setIsLoadingDetails(true);
    getFurtherDetails();
  };

  const getGpsTrackerData = async (requestFromPool = false) => {
    try {
      const response = await trailApi.getpolylinedateforgpstracker(
        deviceId,
        dateFrom,
        timeFrom,
        dateTo,
        timeTo,
        requestFromPool,
        loadAllMarkers,
        gpsMarkerSpanInSeconds
      );

      const centerLat = response.data.CenterLatitude;
      const centerLng = response.data.CenterLongitude;
      const minLat = response.data.MinLatitude;
      const minLng = response.data.MinLongitude;
      const maxLat = response.data.MaxLatitude;
      const maxLng = response.data.MaxLongitude;
      const heading = response.data.Heading;
      setSingleDeviceFilteredOnly(response.data.SingleDeviceFilteredOnly);
      if (response.data.Distance > 0) {
        setGpsTrackerDistance(response.data.Distance);
      }
      setGpsTrackerSpeed(response.data.Speed);
      setGpsTrackerDirection(response.data.Direction);
      setGpsTrackerDuration(response.data.Duration);

      const polygonCamelCaseData = convertKeysToCamelCase(
        response.data.PolylineModel.Polygons
      );

      console.log("polygonCamelCaseData", polygonCamelCaseData);

      setPolygons(polygonCamelCaseData);

      if (mapRef.current) {
        if (!requestFromPool) {
          setCenter({ lat: centerLat, lng: centerLng });
          setMinLatLng({ lat: minLat, lng: minLng });
          setMaxLatLng({ lat: maxLat, lng: maxLng });

          if (maxLat === 0 && maxLng === 0 && minLat === 0 && minLng === 0) {
            const bounds = new window.google.maps.LatLngBounds(
              new window.google.maps.LatLng(35.0, -10.0),
              new window.google.maps.LatLng(71.0, 40.0)
            );
            mapRef.current.fitBounds(bounds);
            mapRef.current.setZoom(5);
          } else {
            const bounds = new window.google.maps.LatLngBounds(
              new window.google.maps.LatLng(minLat, minLng),
              new window.google.maps.LatLng(maxLat, maxLng)
            );
            mapRef.current.fitBounds(bounds);
          }
        } else {
          if (recenterOnAutoRefresh) {
            mapRef.current.panTo({ lat: centerLat, lng: centerLng }); // Smooth animation
          }
        }
      }

      const polylineCamelCaseData = convertKeysToCamelCase(
        response.data.PolylineModel.Polylines
      );
      setPolylines(polylineCamelCaseData);

      setgpsTrackerMarkers(response.data.PolylineModel.TeamMarkers);

      setIsLoadingTrailsData(false);
    } catch (er) {
      console.log(er);
      setIsLoadingTrailsData(false);
    }
  };

  const TrailFromRawData = async () => {
    try {
      const response = await trailApi.trailFromRawData(rawDataId);

      const centerLat = response.data.CenterLatitude;
      const centerLng = response.data.CenterLongitude;
      const minLat = response.data.MinLatitude;
      const minLng = response.data.MinLongitude;
      const maxLat = response.data.MaxLatitude;
      const maxLng = response.data.MaxLongitude;
      if (mapRef.current) {
        setCenter({ lat: centerLat, lng: centerLng });
        setMinLatLng({ lat: minLat, lng: minLng });
        setMaxLatLng({ lat: maxLat, lng: maxLng });

        if (maxLat === 0 && maxLng === 0 && minLat === 0 && minLng === 0) {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(35.0, -10.0),
            new window.google.maps.LatLng(71.0, 40.0)
          );
          mapRef.current.fitBounds(bounds);
          mapRef.current.setZoom(5);
        } else {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(minLat, minLng),
            new window.google.maps.LatLng(maxLat, maxLng)
          );
          mapRef.current.fitBounds(bounds);
        }
      }

      const polylineCamelCaseData = convertKeysToCamelCase(
        response.data.PolylineModel.Polylines
      );
      setPolylines(polylineCamelCaseData);

      setIsLoadingTrailsData(false);
    } catch (er) {
      console.log(er);
      setIsLoadingTrailsData(false);
    }
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const changeMapType = () => {
    const currentMapType = mapRef.current.getMapTypeId();
    setMapType(currentMapType === "hybrid" ? "roadmap" : "hybrid");
    mapRef.current.setMapTypeId(
      currentMapType === "hybrid" ? "roadmap" : "hybrid"
    );
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB3FTLMCjvinLhH622_HKI1WsfYuuKA-vE",
  });

  const [mapType, setMapType] = useState("roadmap");

  const onLoad = React.useCallback(function callback(map) {
    mapRef.current = map;
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    mapRef.current = null;
  }, []);

  const isRequestPending = useRef(false);
  const [isGpsTrackerTrailRequestPending, setIsGpsTrackerTrailRequestPending] =
    useState(false);

  const [showCompleteEditionTrail, setShowCompleteEditionTrail] =
    useState(false);

  const toggleFullEditionTrail = (e) => {
    setShowCompleteEditionTrail(e);
    setSelectedStage({});
    setSelectedTeams([]);
  };

  const [showGpsTrackerTrail, setShowGpsTrackerTrail] = useState(false);
  const [showInAccuracyRange, setShowInAccuracyRange] = useState(false);
  const [gpsAutoRefresh, setGpsAutoRefresh] = useState(true);
  const [loadAllMarkers, setLoadAllMarkers] = useState(false);
  const [recenterOnAutoRefresh, setRecenterOnAutoRefresh] = useState(false);
  const [gpsMarkerSpanInSeconds, setGpsMarkerSpanInSeconds] = useState(60);
  const [singleDeviceFilteredOnly, setSingleDeviceFilteredOnly] =
    useState(false);

  const [gpsTrackerDistance, setGpsTrackerDistance] = useState(0);
  const [gpsTrackerSpeed, setGpsTrackerSpeed] = useState(0);
  const [gpsTrackerDirection, setGpsTrackerDirection] = useState("");
  const [gpsTrackerDuration, setGpsTrackerDuration] = useState("");

  const toggleGpsTrackerTrail = (e) => {
    setShowGpsTrackerTrail(e);
  };

  useEffect(() => {
    // console.log(
    //   "selectedEdition",
    //   selectedEdition ? selectedEdition[0]?.value : 0
    // );
    getFiltersData(showGpsTrackerTrail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showGpsTrackerTrail]);

  const toggleShowInAccuracyRange = (e) => {
    setShowInAccuracyRange(e);
  };

  const toggleGpsAutoRefresh = (e) => {
    setGpsAutoRefresh(e);
  };

  const toggleSetShowAllMarker = (e) => {
    setLoadAllMarkers(e);
  };

  const toggleSetRecenterOnAutoRefresh = (e) => {
    setRecenterOnAutoRefresh(e);
  };

  const [deviceId, setDeviceId] = useState("");
  const [rawDataId, setRawDataId] = useState(0);
  const [inAccuracyMeter, setInAccuracyMeter] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("deviceId");
    const date_from = params.get("dateFrom");
    const date_to = params.get("dateTo");

    if (id) {
      setDeviceId(id);
    }

    if (date_from) {
      setGpsTrakerDateFrom(date_from);
    }

    if (date_to) {
      setGpsTrakerDateTo(date_to);
    }

    if (id || date_from || date_to) {
      setShowGpsTrackerTrail(true);
    }
  }, []);

  const [dateFrom, setGpsTrakerDateFrom] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [timeFrom, setGpsTrakerTimeFrom] = useState("");
  const [dateTo, setGpsTrakerDateTo] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [timeTo, setGpsTrakerTimeTo] = useState("");

  useEffect(() => {
    if (deviceId?.length > 2 && (dateFrom != null || dateTo != null)) {
      getGpsTrackerData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId, dateFrom, timeFrom, dateTo, timeTo, gpsMarkerSpanInSeconds]);

  useEffect(() => {
    TrailFromRawData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawDataId]);

  const [showPOIsMarkers, setShowPOIsMarkers] = useState(false);
  const [showPOIsShapes, setShowPOIsShapes] = useState(false);
  const [showPOIsHitPoints, setShowPOIsHitPoints] = useState(false);
  const [showIgnitionOnOff, setShowIgnitionOnOff] = useState(false);
  const [showStartFinishMarkers, setShowStartFinishMarkers] = useState(false);
  const [showPolyline, setShowPolyline] = useState(false);
  const [showBonusGroupMarkers, setShowBonusGroupMarkers] = useState(false);

  // auto reload of actual trails
  useEffect(() => {
    const doDataRequestForMapData = async () => {
      // Check if a request is already in progress
      if (isRequestPending.current) {
        console.log("Request is still in progress, skipping...");
        return;
      }

      if (
        (selectedTeams ? selectedTeams.map((item) => item.value) : []).length >
          0 ||
        (selectedEdition ? selectedEdition[0]?.value : 0) > 0
      ) {
        console.log("I am requesting");

        // Set request as pending
        isRequestPending.current = true;

        try {
          // Trigger the data fetching function
          await getPolylineData(true);
        } catch (error) {
          console.error("Error while fetching data:", error);
        } finally {
          // Mark the request as completed
          isRequestPending.current = false;
        }
      }
    };

    if (!showCompleteEditionTrail) {
      const interval = setInterval(doDataRequestForMapData, 7000);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedTeams,
    selectedEdition,
    selectedStage,
    getPolylineData,
    showCompleteEditionTrail,
  ]);

  // auto reload of gps tracker trails
  useEffect(() => {
    if (gpsAutoRefresh) {
      const doDataRequestForMapData = async () => {
        if (isGpsTrackerTrailRequestPending) {
          console.log("Request in progress, skipping...");
          return;
        }

        if (
          deviceId?.length > 2 &&
          (dateFrom != null || dateTo != null) &&
          showGpsTrackerTrail
        ) {
          setIsGpsTrackerTrailRequestPending(true);

          try {
            await getGpsTrackerData(true);
          } catch (error) {
            console.error("Error fetching GPS data:", error);
          } finally {
            setIsGpsTrackerTrailRequestPending(false);
          }
        }
      };

      const interval = setInterval(doDataRequestForMapData, 3000);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    deviceId,
    dateFrom,
    timeFrom,
    dateTo,
    timeTo,
    getGpsTrackerData,
    gpsAutoRefresh,
    loadAllMarkers,
    gpsMarkerSpanInSeconds,
  ]);

  const [showFilter, setShowFilter] = useState(false);

  const toggleFilter = () => {
    setShowFilter((prevState) => !prevState);
    setEditingPOIs(false);
  };

  function colorGradient(fadeFraction) {
    let rgbColor1 = {
      red: 92,
      green: 184,
      blue: 91,
    };
    let rgbColor2 = {
      red: 240,
      green: 173,
      blue: 78,
    };
    let rgbColor3 = {
      red: 217,
      green: 83,
      blue: 79,
    };

    var color1 = rgbColor1;
    var color2 = rgbColor2;
    var fade = fadeFraction;

    // Do we have 3 colors for the gradient? Need to adjust the params.
    if (rgbColor3) {
      fade = fade * 2;

      // Find which interval to use and adjust the fade percentage
      if (fade >= 1) {
        fade -= 1;
        color1 = rgbColor2;
        color2 = rgbColor3;
      }
    }

    var diffRed = color2.red - color1.red;
    var diffGreen = color2.green - color1.green;
    var diffBlue = color2.blue - color1.blue;

    var gradient = {
      red: parseInt(Math.floor(color1.red + diffRed * fade), 10),
      green: parseInt(Math.floor(color1.green + diffGreen * fade), 10),
      blue: parseInt(Math.floor(color1.blue + diffBlue * fade), 10),
    };

    return (
      "rgb(" + gradient.red + "," + gradient.green + "," + gradient.blue + ")"
    );
  }

  const [pOIsMarkerPosition, setPOIsMarkerPosition] = useState(null);

  const SelectPOIsLocationOnMap = (event) => {
    if (!editingPOIs) {
      return;
    }

    setPOIsMarkerPosition((prev) => ({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
      poisName: prev?.poisName ?? "", // use previous radius or default to 100
      radius: prev?.radius ?? 100, // use previous radius or default to 100
    }));
  };

  const [editingPOIs, setEditingPOIs] = useState(false);

  const EnablePOIsDesigning = () => {
    setEditingPOIs((prevState) => !prevState);
  };

  useEffect(() => {
    if (!editingPOIs) {
      setPOIsMarkerPosition(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingPOIs]);

  const MaxZoomToPlottedPOIs = () => {
    if (pOIsMarkerPosition) {
      const bounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(
          pOIsMarkerPosition.lat,
          pOIsMarkerPosition.lng
        )
      );
      mapRef.current.fitBounds(bounds);
      mapRef.current.setZoom(16);

      // console.log("i am logged 1");
      // const { lat, lng, radius } = pOIsMarkerPosition;
      // console.log("i am logged 2");
      // // Create Leaflet circle and get bounds
      // const circle = L.circle([lat, lng], { radius });
      // console.log("i am logged 3");
      // const newbounds = circle.getBounds();
      // console.log("i am logged 4");
      // // Fit the map to these bounds with padding
      // mapRef.fitBounds(newbounds, { padding: [20, 20] }); // Padding prevents it from touching edges
      // console.log("i am logged 5");
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const SavePOI = async () => {
    const response = await trailApi.savePoi(
      pOIsMarkerPosition.poisName,
      pOIsMarkerPosition.radius,
      pOIsMarkerPosition.lat,
      pOIsMarkerPosition.lng
    );

    console.log("response", response);

    if (response?.data?.Success) {
      Toast.fire({
        icon: "success",
        title: "POI added successfully!",
      });

      setPOIsMarkerPosition(null);
    } else {
      Toast.fire({
        icon: "error",
        title: response?.data?.Message ?? "Something went wrong!",
      });
    }
  };

  return (
    <>
      {accessToken ? (
        <>
          {isLoaded ? (
            <div className="position-relative">
              {/* Main Content Div */}
              <div className="p-0 bg-light" style={{ height: "100vh" }}>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={12}
                  onLoad={onLoad}
                  onUnmount={onUnmount}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    draggableCursor: editingPOIs ? "pointer" : undefined,
                    draggingCursor: "grab",
                  }}
                  onClick={SelectPOIsLocationOnMap}
                >
                  {/* Map POIs Manual Plotting */}
                  {pOIsMarkerPosition && (
                    <>
                      <Marker
                        position={pOIsMarkerPosition}
                        icon={getTeamNumberSvg("", "#800000")}
                        draggable={true}
                        onDragEnd={(e) =>
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                          }))
                        }
                      />
                      <Circle
                        center={{
                          lat: pOIsMarkerPosition.lat,
                          lng: pOIsMarkerPosition.lng,
                        }}
                        radius={pOIsMarkerPosition.radius}
                        options={{
                          color: "red",
                          fillColor: "red",
                          fillOpacity: 0.1,
                          strokeColor: "red",
                          strokeOpacity: 0.5,
                          strokeWeight: 2,
                        }}
                      />
                    </>
                  )}

                  {/* polygons */}
                  {((showCompleteEditionTrail && showPOIsShapes) ||
                    !showCompleteEditionTrail) &&
                    polygons.map((polygon, index) =>
                      polygon.isCircle ? (
                        <Circle
                          key={index}
                          center={polygon.path[0]}
                          radius={
                            polygon.isFromBackOffice
                              ? polygon.radius
                              : polygon.radius * 1000
                          }
                          options={polygon.options}
                        />
                      ) : (
                        <Polygon
                          key={index}
                          paths={polygon.path}
                          options={polygon.options}
                          onClick={(event) =>
                            setSelectedMarker({
                              polygon: polygon,
                              objectType: "POIsShapes",
                              event,
                            })
                          }
                        />
                      )
                    )}

                  {/* pois highlighting markers */}
                  {((showCompleteEditionTrail && showPOIsMarkers) ||
                    !showCompleteEditionTrail) &&
                    polygons.map(
                      (polygon, index) =>
                        (!(bonusGroupDetails.length > 0) ||
                          (!polygon.poisName.includes("Bonus") &&
                            !polygon.poisName.includes("bonus"))) && (
                          <Marker
                            key={index}
                            position={calculateCenter(polygon.path)}
                            icon={getTeamNumberSvg(
                              extractAndCapitalizePOIsInitial(polygon.poisName),
                              polygon.options.fillColor
                            )}
                            onClick={(event) =>
                              setSelectedMarker({
                                polygon: polygon,
                                objectType: "POIsShapes",
                                event,
                              })
                            }
                          />
                        )
                    )}

                  {/* Polylines */}
                  {((showCompleteEditionTrail && showPolyline) ||
                    !showCompleteEditionTrail) &&
                    polylines.map((polyline, index) => (
                      <Polyline
                        key={index}
                        path={polyline.path}
                        options={{
                          ...polyline.options,
                          icons: [
                            {
                              icon: {
                                path: window.google.maps.SymbolPath
                                  .FORWARD_CLOSED_ARROW,
                                scale: 2,
                                strokeColor: "black",
                              },
                              offset: "50%",
                              repeat: "100px",
                            },
                          ],
                        }}
                      />
                    ))}

                  {/* pois hit markers */}
                  {((showCompleteEditionTrail && showPOIsHitPoints) ||
                    !showCompleteEditionTrail) &&
                    inTrailMarkers.teamInfo.map((team) =>
                      team.markers.map((marker) => (
                        <Marker
                          key={marker.gpsDataId}
                          position={{
                            lat: marker.position.lat,
                            lng: marker.position.lng,
                          }}
                          icon={getInTrailPoisSvg(
                            team.hsl1,
                            team.hsl2,
                            SpeedStatus(marker.pois, marker.speed)
                          )}
                          onClick={(event) =>
                            setSelectedMarker({
                              marker: marker,
                              teamInfo: team,
                              objectType: "InTrailPOIsMarker",
                              event,
                            })
                          }
                          // animation={window.google.maps.Animation.DROP}
                        />
                      ))
                    )}

                  {/* show gps tracker trail markers */}
                  {showGpsTrackerTrail &&
                    gpsTrackerMarkers.map((marker, index) => (
                      <Marker
                        key={index}
                        position={{
                          lat: marker.Path.Lat,
                          lng: marker.Path.Lng,
                        }}
                        icon={(() => {
                          console.log(
                            inAccuracyMeter,
                            marker.Accuracy.toFixed(2)
                          );
                          // const color =
                          //   marker.Accuracy.toFixed(2) >=
                          //     parseFloat(inAccuracyMeter) && inAccuracyMeter > 0
                          //     ? "red"
                          //     : marker.PinColor;
                          const color = colorGradient(
                            marker.Accuracy.toFixed(2) /
                              parseFloat(inAccuracyMeter)
                          );
                          return getInTrailPoisSvg(
                            marker.IsMoving ? color : "red",
                            marker.IsMoving ? color : "red",
                            null,
                            true
                          );
                        })()}
                        onClick={(event) =>
                          setSelectedMarker({
                            marker: marker,
                            objectType: "GpsTrakerMarkers",
                            event,
                          })
                        }
                        // animation={window.google.maps.Animation.DROP}
                      />
                    ))}

                  {showGpsTrackerTrail &&
                    showInAccuracyRange &&
                    gpsTrackerMarkers.map((marker, index) => (
                      <Circle
                        key={index}
                        center={{ lat: marker.Path.Lat, lng: marker.Path.Lng }}
                        radius={marker.Accuracy}
                        options={{
                          strokeColor: marker.PinColor,
                          fillColor: marker.PinColor,
                          fillOpacity: 0.1,
                          strokeOpacity: 0.5,
                        }}
                      />
                    ))}

                  {/* team start finish markers */}
                  {((showCompleteEditionTrail && showStartFinishMarkers) ||
                    !showCompleteEditionTrail) &&
                    startFinishMarkers.map((marker, index) => (
                      <Marker
                        key={index}
                        position={{
                          lat: marker.Path.Lat,
                          lng: marker.Path.Lng,
                        }}
                        icon={getTeamNumberSvg(
                          marker.TeamNumber,
                          marker.PinColor
                        )}
                        onClick={(event) =>
                          setSelectedMarker({
                            marker: marker,
                            objectType: "StartFinishMarker",
                            event,
                          })
                        }
                        // animation={window.google.maps.Animation.DROP}
                      />
                    ))}

                  {/* ignition on off markers */}
                  {((showCompleteEditionTrail && showIgnitionOnOff) ||
                    !showCompleteEditionTrail) &&
                    inTrailPowerOnOffMarkers.teamInfo.map((team) =>
                      team.markers.map((marker) => (
                        <Marker
                          key={marker.gpsDataId}
                          position={{
                            lat: marker.position.lat,
                            lng: marker.position.lng,
                          }}
                          icon={OnTrailPowerOnOff(
                            marker.eventName === "Ignition On"
                              ? "green"
                              : "red",
                            team.hsl1,
                            team.hsl2
                          )}
                          onClick={(event) =>
                            setSelectedMarker({
                              marker: marker,
                              teamInfo: team,
                              objectType: "PowerButtonMarker",
                              event,
                            })
                          }
                        />
                      ))
                    )}

                  {/* non selected teams current location */}
                  {showCurrentLocation &&
                    allOtherTeamsCurrentLocations.map((marker, index) => (
                      <ArcMarker
                        key={index}
                        marker={marker}
                        icon={CarMarker}
                        onClick={(event) =>
                          setSelectedMarker({
                            marker: marker,
                            objectType: "OtherTeamCurrentPosition",
                            event,
                          })
                        }
                      />
                    ))}

                  {/* bonus group markers */}
                  {((showCompleteEditionTrail && showBonusGroupMarkers) ||
                    !showCompleteEditionTrail) &&
                    bonusGroupDetails.map((marker, index) => (
                      <Marker
                        key={index}
                        position={{ lat: marker.Lat, lng: marker.Lng }}
                        icon={getTeamNumberSvg(
                          marker.IconName === "All"
                            ? "✔"
                            : marker.IconName === "Some"
                            ? "?"
                            : "!",
                          marker.MarkerColor
                        )}
                        onClick={(event) =>
                          setSelectedMarker({
                            marker: marker,
                            objectType: "BonusGroupMarker",
                            event,
                          })
                        }
                        // animation={window.google.maps.Animation.DROP}
                      />
                    ))}

                  {/* markers generic popup */}
                  {selectedMarker && (
                    <InfoWindow
                      position={
                        selectedMarker.objectType === "StartFinishMarker"
                          ? {
                              lat: selectedMarker.marker.Path.Lat,
                              lng: selectedMarker.marker.Path.Lng,
                            }
                          : selectedMarker.objectType === "InTrailPOIsMarker"
                          ? selectedMarker.marker.position
                          : selectedMarker.objectType === "PowerButtonMarker"
                          ? selectedMarker.marker.position
                          : selectedMarker.objectType ===
                            "OtherTeamCurrentPosition"
                          ? selectedMarker.event.latLng
                          : selectedMarker.objectType === "BonusGroupMarker"
                          ? {
                              lat: selectedMarker.marker.Lat,
                              lng: selectedMarker.marker.Lng,
                            }
                          : selectedMarker.objectType === "GpsTrakerMarkers"
                          ? selectedMarker.event.latLng
                          : selectedMarker.event.latLng
                      }
                      onCloseClick={() => setSelectedMarker(null)} // Close the InfoWindow
                    >
                      <div>
                        {selectedMarker.objectType === "StartFinishMarker" ? (
                          <>
                            {selectedMarker.marker.IsStart ? (
                              <h3>Team Start Info</h3>
                            ) : (
                              <h3>Team Current Info</h3>
                            )}
                            <p>
                              Team: {selectedMarker.marker.TeamNumber}{" "}
                              {selectedMarker.marker.TeamName}
                            </p>
                            <p>Speed: {selectedMarker.marker.Speed}</p>
                            <p>Direction: {selectedMarker.marker.Direction}</p>
                            <p>
                              Occurred Time:{" "}
                              {selectedMarker.marker.OccuredOnLocal}
                            </p>
                          </>
                        ) : selectedMarker.objectType === "GpsTrakerMarkers" ? (
                          <>
                            <h3>Gps Tracker Info</h3>
                            <table className="table">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Record Id:</strong>
                                  </td>
                                  <td>{selectedMarker.marker.RecordId}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Team:</strong>
                                  </td>
                                  <td>{selectedMarker.marker.TeamName}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Speed #1:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.Speed.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Speed #2:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.ManualSpeed.toFixed(
                                      2
                                    )}
                                  </td>
                                </tr>
                                {selectedMarker?.marker?.HitPOIsList?.map(
                                  (hit, index) => (
                                    <tr key={index}>
                                      <td>
                                        <b>{`Hit POIs #${index + 1}:`}</b>
                                      </td>
                                      <td>{hit}</td>
                                    </tr>
                                  )
                                )}
                                <tr>
                                  <td>
                                    <strong>Odometer:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.Odometer.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Occurred Time:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.OccuredOnLocal}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>From Background:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker
                                      .IsFromBackGroundTask ? (
                                      <span style={{ color: "green" }}>✔️</span>
                                    ) : (
                                      <span style={{ color: "red" }}>❌</span>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Is Moving?</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.IsMoving ? (
                                      <span style={{ color: "green" }}>✔️</span>
                                    ) : (
                                      <span style={{ color: "red" }}>❌</span>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Accuracy:</strong>
                                  </td>
                                  <td>
                                    {selectedMarker.marker.Accuracy.toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        ) : selectedMarker.objectType ===
                          "InTrailPOIsMarker" ? (
                          <>
                            <h3>POIs Hit Info</h3>
                            <p>Team: {selectedMarker.teamInfo.teamNumber}</p>
                            <p>Speed: {selectedMarker.marker.speed}</p>
                            <p>Direction: {selectedMarker.marker.direction}</p>
                            <p>
                              Occurred Time:{" "}
                              {selectedMarker.marker.occuredTimeToLocal}
                            </p>
                          </>
                        ) : selectedMarker.objectType ===
                          "PowerButtonMarker" ? (
                          <>
                            <h3>POIs Hit Info</h3>
                            <p>Team: {selectedMarker.teamInfo.teamNumber}</p>
                            <p>Speed: {selectedMarker.marker.speed}</p>
                            <p>Direction: {selectedMarker.marker.direction}</p>
                            <p>Event Name: {selectedMarker.marker.eventName}</p>
                            <p>
                              Occurred Time:{" "}
                              {selectedMarker.marker.occuredTimeToLocal}
                            </p>
                          </>
                        ) : selectedMarker.objectType === "BonusGroupMarker" ? (
                          <>
                            <h3>Bonus Group Info</h3>
                            <p>Group Name: {selectedMarker.marker.GroupName}</p>
                            <p>POIs: {selectedMarker.marker.Pois}</p>
                            <p>
                              Total Points: {selectedMarker.marker.TotalPoints}
                            </p>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Team</th>
                                  <th>Gained</th>
                                  <th>Occured On</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedMarker.marker.TeamStates.map(
                                  (team, index) => (
                                    <tr key={index}>
                                      <td>{team.TeamNumber}</td>
                                      <td>{team.TeamName}</td>
                                      <td>{team.IsAquaired ? "✔" : "X"}</td>
                                      <td>{team.OccuredOnLocal}</td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </>
                        ) : selectedMarker.objectType ===
                          "OtherTeamCurrentPosition" ? (
                          <>
                            <h3>Team Current Info</h3>
                            <table className="table">
                              <tbody>
                                <tr>
                                  <th>#</th>
                                  <td>{selectedMarker.marker.TeamNumber}</td>
                                </tr>
                                <tr>
                                  <th>Team Name</th>
                                  <td>{selectedMarker.marker.TeamName}</td>
                                </tr>
                                <tr>
                                  <th>Asset</th>
                                  <td>{selectedMarker.marker.AssetId}</td>
                                </tr>
                                <tr>
                                  <th>Speed</th>
                                  <td>{selectedMarker.marker.Speed}</td>
                                </tr>
                                <tr>
                                  <th>Odometer</th>
                                  <td>{selectedMarker.marker.Odometer}</td>
                                </tr>
                                <tr>
                                  <th>Direction</th>
                                  <td>{selectedMarker.marker.DirectionName}</td>
                                </tr>
                                <tr>
                                  <th>Occured On:</th>
                                  <td>
                                    {selectedMarker.marker.OccuredOnLocalString}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Event</th>
                                  <td>
                                    {selectedMarker.marker.EventNumber}
                                    {" - "}
                                    {selectedMarker.marker.EventName}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <>
                            <h3>POIs Shape Info</h3>
                            <p>POIs Name: {selectedMarker.polygon.poisName}</p>
                          </>
                        )}
                      </div>
                    </InfoWindow>
                  )}
                </GoogleMap>

                {/* Drawer */}
                <Drawer
                  open={isOpen}
                  onClose={toggleDrawer}
                  direction="right"
                  className="bla bla bla"
                  enableOverlay={false}
                  style={drawerStyle}
                  size={
                    windowSize.width > 700 ? "700px" : windowSize.width - 50
                  }
                >
                  <Tooltip title="Reload Details">
                    <span onClick={reloadDetails} style={{ cursor: "pointer" }}>
                      {RefreshIcon()}
                    </span>
                  </Tooltip>
                  <Tooltip title="Close Drawer">
                    <span
                      onClick={toggleDrawer}
                      style={{ cursor: "pointer", float: "right" }}
                    >
                      {CrossIcon()}
                    </span>
                  </Tooltip>
                  <div
                    style={{
                      overflowY: "auto",
                      maxHeight: "100vh",
                      padding: "16px",
                    }}
                  >
                    {isLoadingDetails ? (
                      <Stack spacing={1}>
                        {selectedTeams.map((index) => (
                          <Skeleton
                            key={index}
                            variant="rectangular"
                            width={580}
                            height={63}
                          />
                        ))}
                      </Stack>
                    ) : (
                      stageTeamJourneys.map((journeyData, index) => (
                        <TeamDetails
                          key={index}
                          expanded={expanded}
                          handleChange={handleChange}
                          accordionKey={journeyData.TeamId}
                          journeyData={journeyData}
                        />
                      ))
                    )}
                  </div>
                </Drawer>
              </div>

              {/* menu icons div */}
              <div className="position-absolute top-0 start-0 bg-none p-3 d-block">
                <Tooltip title="Draw POIs">
                  <button
                    type="button"
                    onClick={EnablePOIsDesigning}
                    style={{
                      borderRadius: "50%",
                      width: "45px",
                      height: "45px",
                      marginLeft: "5px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {editingPOIs ? DrawIcon() : DrawIconDisable()}
                  </button>
                </Tooltip>
                {!editingPOIs && (
                  <Tooltip title="Toggle Filters">
                    <button
                      type="button"
                      style={{
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        backgroundColor: "#fff",
                      }}
                      onClick={toggleFilter}
                    >
                      {showFilter ? ShowFilterIcon() : HideFilterIcon()}
                    </button>
                  </Tooltip>
                )}
                <Tooltip title="Change Map Type">
                  <button
                    type="button"
                    style={{
                      borderRadius: "50%",
                      width: "45px",
                      height: "45px",
                      marginLeft: "5px",
                      backgroundColor: "#fff",
                    }}
                    onClick={changeMapType}
                  >
                    {mapType === "roadmap" ? Satelite() : RoadMap()}
                  </button>
                </Tooltip>
                <Tooltip title="Recenter">
                  <button
                    type="button"
                    onClick={ReCenterToEurope}
                    style={{
                      borderRadius: "50%",
                      width: "45px",
                      height: "45px",
                      marginLeft: "5px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {MapRecenter()}
                  </button>
                </Tooltip>

                {(selectedEdition ? selectedEdition[0]?.value : 0) > 0 && (
                  <Tooltip title="Toggle Car Pins">
                    <button
                      type="button"
                      style={{
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        marginLeft: "5px",
                        backgroundColor: "#fff",
                      }}
                      onClick={togglePins}
                      disabled={
                        (selectedEdition ? selectedEdition[0]?.value : 0) > 0
                          ? false
                          : true
                      }
                    >
                      {showCurrentLocation ? HideCarIcon() : ShowCarIcon()}
                    </button>
                  </Tooltip>
                )}
                {selectedTeams && selectedTeams.length > 0 && (
                  <Tooltip title="Toggle Details">
                    <button
                      type="button"
                      onClick={toggleDrawer}
                      disabled={
                        selectedTeams && selectedTeams.length > 0 ? false : true
                      }
                      style={{
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        marginLeft: "5px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {!isOpen ? <ShowDetailsIcon /> : <HideDetailsIcon />}
                    </button>
                  </Tooltip>
                )}
              </div>
              {/* filter div */}
              <div
                className={`position-absolute top-0 start-0 bg-none p-4 ${
                  showFilter ? "d-block" : "d-none"
                }`}
                style={{
                  width: "300px",
                  height: "50vh",
                  marginTop: "50px",
                }}
              >
                <div className="row bg-white">
                  {!showGpsTrackerTrail && (
                    <div
                      className="col-12"
                      style={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      <MultiselectDropdown
                        styles={{
                          searchBox: {
                            border: "1px solid #000",
                            borderRadius: "5px",
                            width: "100%",
                          },
                        }}
                        options={editions}
                        selectedvals={selectedEdition}
                        setSelectedVals={setSelectedEdition}
                        isSingleSelect={true}
                        placeholder={"Select Edition"}
                        id={"edition"}
                      />
                    </div>
                  )}
                  {!showCompleteEditionTrail && !showGpsTrackerTrail && (
                    <div className="col-12" style={{ marginBottom: "10px" }}>
                      <MultiselectDropdown
                        styles={{
                          searchBox: {
                            border: "1px solid #000",
                            borderRadius: "5px",
                            width: "100%",
                          },
                        }}
                        options={stages}
                        selectedvals={selectedStage}
                        setSelectedVals={setSelectedStage}
                        isSingleSelect={true}
                        placeholder={"Select Stage"}
                        id={"stage"}
                      />
                    </div>
                  )}
                  {!showGpsTrackerTrail && (
                    <div className="col-12" style={{ marginBottom: "10px" }}>
                      <input
                        type="checkbox"
                        id="completeEditionTrailCheckbox"
                        className="form-check-input"
                        checked={showCompleteEditionTrail}
                        onChange={(e) =>
                          toggleFullEditionTrail(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="completeEditionTrailCheckbox"
                        style={{ marginLeft: "10px" }}
                      >
                        {showCompleteEditionTrail
                          ? "Hide Full Edition Trail"
                          : "Show Full Edition Trail"}
                      </label>
                    </div>
                  )}

                  <div
                    className="col-12"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    <input
                      type="checkbox"
                      id="gpsTrackerTrail"
                      className="form-check-input"
                      checked={showGpsTrackerTrail}
                      onChange={(e) => toggleGpsTrackerTrail(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="gpsTrackerTrail"
                      style={{ marginLeft: "10px" }}
                    >
                      {showGpsTrackerTrail
                        ? "Hide Gps Tracker Trail"
                        : "Show Gps Tracker Trail"}
                    </label>
                  </div>

                  <div
                    className="col-12"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    <MultiselectDropdown
                      styles={{
                        searchBox: {
                          border: "1px solid #000",
                          borderRadius: "5px",
                          width: "100%",
                        },
                        optionContainer: {
                          border: "1px solid #ddd",
                          borderRadius: "5px",
                          backgroundColor: "#fff",
                          width: "252px",
                        },
                      }}
                      options={teams}
                      selectedvals={selectedTeams}
                      setSelectedVals={setSelectedTeams}
                      placeholder={"Select Teams"}
                      id={"teams"}
                      isSingleSelect={
                        showCompleteEditionTrail || showGpsTrackerTrail
                      }
                    />
                  </div>

                  {showGpsTrackerTrail && (
                    <>
                      <div className="col-12 my-2" style={{ display: "none" }}>
                        <input
                          type="text"
                          id="deviceId"
                          className="form-control"
                          value={deviceId}
                          onChange={(e) => setDeviceId(e.target.value)}
                          placeholder="Enter Device ID"
                        />
                      </div>
                      <div className="col-12 my-2">
                        GPS Raw Data Id:
                        <input
                          type="text"
                          id="deviceId"
                          className="form-control"
                          value={rawDataId}
                          onChange={(e) => setRawDataId(e.target.value)}
                          placeholder="Enter Raw Data Id"
                        />
                      </div>
                      <div className="col-12 my-2">
                        In Accuracy Meter:
                        <input
                          type="text"
                          id="inAccuracyMeter"
                          className="form-control"
                          value={inAccuracyMeter}
                          onChange={(e) => setInAccuracyMeter(e.target.value)}
                          placeholder="Enter In Accuracy Meter"
                        />
                      </div>
                      <div
                        className="col-12"
                        style={{ marginBottom: "10px", marginTop: "10px" }}
                      >
                        <input
                          type="checkbox"
                          id="InAccuracyRange"
                          className="form-check-input"
                          checked={showInAccuracyRange}
                          onChange={(e) =>
                            toggleShowInAccuracyRange(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="InAccuracyRange"
                          style={{ marginLeft: "10px" }}
                        >
                          {showInAccuracyRange
                            ? "Hide In Accuracy Range"
                            : "Show In Accuracy Range"}
                        </label>
                      </div>
                      <div
                        className="col-12"
                        style={{ marginBottom: "10px", marginTop: "10px" }}
                      >
                        <input
                          type="checkbox"
                          id="GpsAutoRefresh"
                          className="form-check-input"
                          checked={gpsAutoRefresh}
                          onChange={(e) =>
                            toggleGpsAutoRefresh(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="GpsAutoRefresh"
                          style={{ marginLeft: "10px" }}
                        >
                          {gpsAutoRefresh
                            ? "Disable Auto-Refresh"
                            : "Enable Auto-Refresh"}
                        </label>
                      </div>
                      <div
                        className="col-12"
                        style={{ marginBottom: "10px", marginTop: "10px" }}
                      >
                        <input
                          type="checkbox"
                          id="recenterOnAutoRefresh"
                          className="form-check-input"
                          checked={recenterOnAutoRefresh}
                          onChange={(e) =>
                            toggleSetRecenterOnAutoRefresh(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="recenterOnAutoRefresh"
                          style={{ marginLeft: "10px" }}
                        >
                          {recenterOnAutoRefresh
                            ? "Disable Auto Recenter"
                            : "Enable Auto Recenter"}
                        </label>
                      </div>
                      <div
                        className="col-12"
                        style={{ marginBottom: "10px", marginTop: "10px" }}
                      >
                        <input
                          type="checkbox"
                          id="ShowAllMarkers"
                          className="form-check-input"
                          checked={loadAllMarkers}
                          onChange={(e) =>
                            toggleSetShowAllMarker(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="ShowAllMarkers"
                          style={{ marginLeft: "10px" }}
                        >
                          {loadAllMarkers
                            ? "Show Limited Markers"
                            : "Show All Markers"}
                        </label>
                      </div>
                      {!loadAllMarkers && (
                        <div className="col-12 my-2">
                          <input
                            type="number"
                            id="gpsMarkerSpanInSeconds"
                            className="form-control"
                            value={gpsMarkerSpanInSeconds}
                            onChange={(e) =>
                              setGpsMarkerSpanInSeconds(
                                parseInt(e.target.value)
                              )
                            }
                            placeholder="Enter GPS Markers' Span In Seconds"
                          />
                        </div>
                      )}
                      <div className="col-12 my-2">
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            Date From:
                            <input
                              type="date"
                              id="dateFrom"
                              className="form-control"
                              value={dateFrom}
                              onChange={(e) =>
                                setGpsTrakerDateFrom(e.target.value)
                              } // Correct function to update state
                              placeholder="Select a date"
                            />
                          </div>
                          <div className="col-md-6 col-sm-6">
                            Time From:
                            <input
                              type="time"
                              id="timeFrom"
                              className="form-control"
                              value={timeFrom}
                              onChange={(e) =>
                                setGpsTrakerTimeFrom(e.target.value)
                              } // Correct function to update state
                              placeholder="Select a date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 my-2">
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            Date To:
                            <input
                              type="date"
                              id="dateTo"
                              className="form-control"
                              value={dateTo}
                              onChange={(e) =>
                                setGpsTrakerDateTo(e.target.value)
                              } // Correct function to update state
                              placeholder="Select a date"
                            />
                          </div>
                          <div className="col-md-6 col-sm-6">
                            Time To:
                            <input
                              type="time"
                              id="timeTo"
                              className="form-control"
                              value={timeTo}
                              onChange={(e) =>
                                setGpsTrakerTimeTo(e.target.value)
                              } // Correct function to update state
                              placeholder="Select a date"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {isLoadingTrailsData && Loader()}
                  {showCompleteEditionTrail && (
                    <>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="trailCheckbox"
                          className="form-check-input"
                          checked={showPolyline}
                          onChange={(e) => setShowPolyline(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="trailCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showPolyline ? "Hide Team Trail" : "Show Team Trail"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="poisMarkerCheckbox"
                          className="form-check-input"
                          checked={showPOIsMarkers}
                          onChange={(e) => setShowPOIsMarkers(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="poisMarkerCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showPOIsMarkers
                            ? "Hide POIs Markers"
                            : "Show POIs Markers"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="poisShapesCheckbox"
                          className="form-check-input"
                          checked={showPOIsShapes}
                          onChange={(e) => setShowPOIsShapes(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="poisShapesCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showPOIsShapes
                            ? "Hide POIs Shapes"
                            : "Show POIs Shapes"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="bonusGroupMarkersCheckbox"
                          className="form-check-input"
                          checked={showBonusGroupMarkers}
                          onChange={(e) =>
                            setShowBonusGroupMarkers(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="bonusGroupMarkersCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showBonusGroupMarkers
                            ? "Hide Bonus Group Markers"
                            : "Show Bonus Group Markers"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="poisHitPoint"
                          className="form-check-input"
                          checked={showPOIsHitPoints}
                          onChange={(e) =>
                            setShowPOIsHitPoints(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="poisHitPoint"
                          style={{ marginLeft: "10px" }}
                        >
                          {showPOIsHitPoints
                            ? "Hide POIs Hit Points"
                            : "Show POIs Hit Points"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="ignitionOnOffCheckbox"
                          className="form-check-input"
                          checked={showIgnitionOnOff}
                          onChange={(e) =>
                            setShowIgnitionOnOff(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="ignitionOnOffCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showIgnitionOnOff
                            ? "Hide Ignition On/Off"
                            : "Show Ignition On/Off"}
                        </label>
                      </div>
                      <div className="col-12" style={{ marginBottom: "10px" }}>
                        <input
                          type="checkbox"
                          id="startFinishMarkersCheckbox"
                          className="form-check-input"
                          checked={showStartFinishMarkers}
                          onChange={(e) =>
                            setShowStartFinishMarkers(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="startFinishMarkersCheckbox"
                          style={{ marginLeft: "10px" }}
                        >
                          {showStartFinishMarkers
                            ? "Hide Start/Finish Markers"
                            : "Show Start/Finish Markers"}
                        </label>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* POIs Designing Div */}
              <div
                className={`position-absolute top-0 start-0 bg-none p-4 ${
                  !showFilter && editingPOIs && pOIsMarkerPosition
                    ? "d-block"
                    : "d-none"
                }`}
                style={{
                  width: "300px",
                  height: "50vh",
                  marginTop: "50px",
                }}
              >
                <div className="row bg-white">
                  <>
                    <div className="col-12 my-2">
                      <input
                        type="text"
                        id="POIsName"
                        className="form-control"
                        value={pOIsMarkerPosition?.poisName ?? ""}
                        onChange={(e) =>
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            poisName: e.target.value,
                          }))
                        }
                        placeholder="Enter POIs Name"
                      />
                    </div>
                    <div className="col-12 my-2">
                      <input
                        type="number"
                        id="inAccuracyMeter"
                        className="form-control"
                        value={pOIsMarkerPosition?.radius ?? 0}
                        onChange={(e) =>
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            radius: Number(e.target.value),
                          }))
                        }
                        placeholder="Enter In Accuracy Meter"
                      />
                    </div>
                    <div className="col-12 my-2">
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ width: "60px" }}>{"Lat: "}</td>
                            <td>
                              <b>{pOIsMarkerPosition?.lat ?? ""}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>{"Lng: "}</td>
                            <td>
                              <b>{pOIsMarkerPosition?.lng ?? ""}</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 my-2">
                      <Tooltip title="Max Zoom to View Nearby Area For Plotting POIs">
                        <button
                          type="button"
                          onClick={MaxZoomToPlottedPOIs}
                          style={{
                            borderRadius: "5%",
                            height: "45px",
                            width: "100%",
                            backgroundColor: "#fff",
                          }}
                        >
                          {"View with Full Zoom"} {FocusIcon()}
                        </button>
                      </Tooltip>
                    </div>
                    <div className="col-12 my-2">
                      <Tooltip title="Save POIs In Database">
                        <button
                          type="button"
                          onClick={SavePOI}
                          style={{
                            borderRadius: "5%",
                            height: "45px",
                            width: "100%",
                            backgroundColor: "#2c786c",
                            color: "#fff",
                          }}
                        >
                          {"Save POIs"}
                        </button>
                      </Tooltip>
                    </div>
                  </>
                </div>
              </div>
              {/* Gps Tracker Car Live Info */}
              {showGpsTrackerTrail && singleDeviceFilteredOnly && (
                <div className="position-absolute top-0 end-0 bg-none p-3 d-block">
                  <div
                    className="bg-white p-1"
                    style={{
                      width: "175px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <label className="form-check-label fw-bolder">
                      Device: {deviceId}
                    </label>
                  </div>
                  <div
                    className="bg-white p-1"
                    style={{
                      marginTop: "5px",
                      width: "175px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <label className="form-check-label fw-bolder">
                      Speed:{" "}
                      {gpsTrackerSpeed > 0 ? gpsTrackerSpeed.toFixed(2) : 0}{" "}
                      km/h
                    </label>
                  </div>
                  <div
                    className="bg-white p-1"
                    style={{
                      marginTop: "5px",
                      width: "175px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <label className="form-check-label fw-bolder">
                      Distance:{" "}
                      {gpsTrackerDistance > 0
                        ? gpsTrackerDistance.toFixed(2)
                        : 0}{" "}
                      km
                    </label>
                  </div>
                  <div
                    className="bg-white p-1"
                    style={{
                      marginTop: "5px",
                      width: "175px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <label className="form-check-label fw-bolder">
                      Heading:{" "}
                      {gpsTrackerDirection ? gpsTrackerDirection : "N/A"}
                    </label>
                  </div>
                  <div
                    className="bg-white p-1"
                    style={{
                      marginTop: "5px",
                      width: "175px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <label className="form-check-label fw-bolder">
                      Duration:{" "}
                      {gpsTrackerDuration ? gpsTrackerDuration : "N/A"}
                    </label>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <LoginPage setAccessToken={setAccessToken} />
      )}
    </>
  );
}

const drawerStyle = {
  background: "rgba(255, 255, 255, 1)",
  padding: "5px 10px",
  borderRadius: "10px 0px 0px 10px",
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
  direction: "row",
};

export default Index;
